import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  {
    x: 1450,
    y: 1270,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png',
    flipSprite : true,
    repeatable : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Banyak kenangan baik di tempat ini. Walau hanya sebentar`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Tetapi, sudah saatnya aku pulang`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_2a",
        },
        elsa_2a: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Walaupun aku juga merasa bersalah atas kematian Diana`,
          characterImage: '/assets/character/v2/elsa_s.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_3",
        },
        //TODO elsa ini bukan salah mu
        //            {
        //               text: 'Kematian Diana bukan salah mu Elsa',
        //               storyAction: { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
        //               nextDialogId: 'elsa_4',
        //             },
        elsa_3: {
          id: 'elsa_1',
          characterImage: '/assets/character/v2/elsa_s.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          speaker: '',
          text: ``,
          choices: [
            {
              text: 'Aku masih ingin disini. Aku mau membalas dendam Diana.',
              nextDialogId: 'elsa_4',
            },
            {
              text: 'Aku masih ingin disini. Aku tidak mau meninggalkan Bunga',
              nextDialogId: 'elsa_4',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_affinity", value : 1} },
              //TODO if affection
            },
            {
              text: 'Ayo kita pulang.',
              nextDialogId: 'day1_opening5',
              storyAction: { type: 'nextDay', value: 0 },
            },
          ],
        },
        elsa_4: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan, aku paham. Tapi tempat ini sangat berbahaya`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_5",
        },
        elsa_5: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Percaya padaku. Kita harus..`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_6",
        },
        elsa_6: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Itu dia! Tangkap dia!`,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_7",
        },
        elsa_7: {
          id: 'elsa_1',
          speaker: '',
          text: `Ayo!!!`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_8",
        },
        elsa_8: {
          id: 'elsa_1',
          speaker: 'Holga',
          text: `Pendatang itu, membunuh anak saya! Jangan biarkan dia pergi!`,
          characterImage: '/assets/character/v2/holga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_9",
        },
        elsa_9: {
          id: 'elsa_1',
          speaker: 'Holga',
          text: `Dia harus bertanggung jawab`,
          characterImage: '/assets/character/v2/holga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_10",
        },
        elsa_10: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan! Tolong!`,
          characterImage: '/assets/character/v2/elsa_p.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',//TODO gambar ato gendong elsa
          nextDialogId : "elsa_11",
        },
        elsa_11: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa_p.png',
          choices: [
            {
              text: 'Kejar Elsa',
              nextDialogId: 'elsa_12',
              storyActions : [
                { type: 'addState', value: "BUNGA_NOT_WITH_ELSA" },
                { type: 'addState', value: "ATO_UNFRIENDLY" },
                { type: 'addState', value: "ELSA_ON_STAKE" },
              ], //normal option
            },
            {
              text: 'Serang Ato',
              nextDialogId: 'elsa_a1',
              storyActions : [
                { type: 'addState', value: "BUNGA_NOT_WITH_ELSA" },
                { type: 'addState', value: "ATO_UNFRIENDLY" },
                { type: 'addState', value: "ELSA_ON_STAKE" },
              ],
              //todo opsi if kalau general karma rendah
            },
            {
              text: 'Teriak minta tolong',
              nextDialogId: 'elsa_b1',
              storyActions : [
                { type: 'addState', value: "BUNGA_WITH_ELSA" },
                { type: 'addState', value: "ATO_UNFRIENDLY" },
                { type: 'addState', value: "ELSA_NOT_ON_STAKE" },
              ],
              //todo bunga option, tambah if bunga affection high dan bunga elsa high
            },
            {
              text: 'Memohon kepada Ato',
              nextDialogId: 'elsa_c1',//todo ato option if ato high and anak kecil beruang
              storyActions : [
                { type: 'addState', value: "BUNGA_NOT_WITH_ELSA" },
                { type: 'addState', value: "ATO_FRIENDLY" },
                { type: 'addState', value: "ELSA_NOT_ON_STAKE" },
              ],
            },
          ],
        },

        elsa_c1: {
          id: 'elsa_1',
          speaker: 'Yan',
          text: `Ato aku mohon!`,
          characterImage: '/assets/character/v2/yanf.png',//TODO Yan determiend / sympatethic
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c2",
        },
        elsa_c2: {
          id: 'elsa_1',
          speaker: 'Yan',
          text: `Lepaskan Elsa!`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c3",
        },
        elsa_c3: {
          id: 'elsa_1',
          speaker: 'Itje',
          text: `Ayah! Dengarkan kak Yan!`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c4",
        },
        elsa_c4: {
          id: 'elsa_1',
          speaker: 'Itje',
          text: `Kak Yan orang baik, jangan sakiti kak Yan.`,
          characterImage: '/assets/character/v2/little_girl_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c5",
        },
        elsa_c5: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Itje..... `,
          characterImage: '/assets/character/v2/ato_sy.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c6",
        },
        elsa_c6: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Maaf kan aku. Aku terbawa emosi.`,
          characterImage: '/assets/character/v2/ato_sy.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c7",
        },
        elsa_c7: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Tapi kamu dan teman mu tidak boleh keluar dari desa ini sampai kasus ini tuntas.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c8",
        },
        elsa_c8: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Baiklah aku paham.`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c9",
        },
        elsa_c9: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Aku tidak akan lari dari tempat ini.`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c10",
        },
        elsa_c10: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Tapi aku ingin kalian semua tahu, bukan aku yang membunuh Diana maupun Sondakh!`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c11",
        },
        elsa_c11: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Aku baru kenal Diana sebentar tapi percayalah aku sangat sayang Diana. Tidak mungkin aku lakukan itu`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c12",
        },
        elsa_c12: {
          id: 'elsa_1',
          speaker: 'Holga',
          text: `Diam kamu! Seseorang harus bertanggung jawab!`,
          characterImage: '/assets/character/v2/holga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c13",
        },
        elsa_c13: {
          id: 'elsa_1',
          speaker: '',
          text: `Betul! Kita tidak percaya dia tidak akan kabur! Tahan dia!`,
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c14",
          //todo sfx rowdy noises
        },
        elsa_c14: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Yan, sepertinya, kita tetap harus menyerahkan Elsa.`,
          characterImage: '/assets/character/v2/ato.png',//todo ato sympatethic
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c15",
        },
        elsa_c15: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Tapi aku jamin Elsa tidak akan kami sakiti sampai terbukti bersalah.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c16",
        },
        elsa_c16: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          choices : [
            {
              text: 'Aku percaya kepada mu Ato, tolong jaga Elsa',
              nextDialogId: 'elsa_c17',
              //TODO add affinity ato
            },
            {
              text: 'Elsa, jangan takut. Aku pasti akan membuktikan kamu tidak bersalah',
              nextDialogId: 'elsa_c17',
              //TODO add affinity elsa
            },
          ],
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_a2",
        },
        elsa_c17: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan, aku percaya kepada kamu. Buktikan aku tidak bersalah.`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_c18",
        },
        elsa_c18: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Sampai Jumpa Yan`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          storyAction: { type: 'nextDay', value: 2 },
        },

        elsa_b1: {
          id: 'elsa_d1',
          speaker: 'Yan',
          text: `Tolongg!!`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b2",
        },
        elsa_b2: {
          id: 'elsa_d1',
          speaker: 'Yan',
          text: `Tolongg!!`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b3",
        },
        elsa_b3: {
          id: 'elsa_d1',
          speaker: 'Bunga',
          text: `Semuanya, hentikan!`,
          characterImage: '/assets/character/v2/bunga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b4",
        },
        elsa_b4: {
          id: 'elsa_d1',
          speaker: 'Bunga',
          text: `Yan adalah orang baik. Setidaknya kita mendengar pendapat dulu.`,
          characterImage: '/assets/character/v2/bunga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b5",
        },
        elsa_b5: {
          id: 'elsa_d1',
          speaker: 'Bunga',
          text: `Aku juga awalnya tidak menyukai Elsa. Tapi aku percaya dengan Yan.`,
          characterImage: '/assets/character/v2/bunga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b6",
        },
        elsa_b6: {
          id: 'elsa_d1',
          speaker: 'Holga',
          text: `Kamu jangan tertipu dengan Yan! Dia sudah ditipu oleh temannya!`,
          characterImage: '/assets/character/v2/holga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b7",
        },
        elsa_b7: {
          id: 'elsa_d1',
          speaker: 'Ato',
          text: `Salah satu orang harus bertanggung jawab atas kematian di desa ini!`,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b8",
        },
        elsa_b8: {
          id: 'elsa_d1',
          speaker: 'Bunga',
          text: `Elsa, kamu tidak akan kabur kan?`,
          characterImage: '/assets/character/v2/bunga.png',//todo bunga sympatethic
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b9",
        },
        elsa_b9: {
          id: 'elsa_d1',
          speaker: 'Elsa',
          text: `Aku akan memberanikan diri. Karena aku tidak bersalah.`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b10",
        },
        elsa_b10: {
          id: 'elsa_d1',
          speaker: 'Elsa',
          text: `Tapi aku juga lengah dan membiarkan Diana mati sendiri. Aku tidak akan kabur.`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b11",
        },
        elsa_b11: {
          id: 'elsa_d1',
          speaker: 'Bunga',
          text: `Yan. Aku akan menemani Elsa.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_b12",
          storyActions : [
            { type: 'addState', value: "BUNGA_WITH_ELSA" },
          ],
        },
        elsa_b12: {
          id: 'elsa_d1',
          speaker: 'Bunga',
          text: `Kamu harus bisa membuktikan Elsa tidak bersalah kepada yang lain.`,
          characterImage: '/assets/character/v2/bunga_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          storyAction: { type: 'nextDay', value: 2 },
        },

        elsa_a1: {
          id: 'elsa_1',
          speaker: 'Yan',
          text: `Lepaskan Elsa`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_a2",
        },
        elsa_a2: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Kamu, kamu juga terlibat ya?`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_a3",
        },
        elsa_a3: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Kamu juga, harus membayar semua ini.`,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_a4",
        },
        elsa_a4: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_a5",
        },
        elsa_a5: {
          id: 'elsa_1',
          speaker: '???',
          text: `Ayo!! Serang mereka`,
          backgroundImage: '/assets/cutscene/death_crowd_2.ktx2',
          nextDialogId : "elsa_a6",
          //todo sfx suara keributan serang2an
        },
        elsa_a6: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/death_crowd_3.ktx2',
          nextDialogId : "elsa_a7",
          //todo sfx suara keributan serang2an
        },
        elsa_a7: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/death_crowd_4.ktx2',
          isGameOver : true
        },
        elsa_12: {
          id: 'elsa_1',
          speaker: 'Yan',
          text: `Hentikan!!`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_12a",
        },
        elsa_12a: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: `Kamu jangan ikut campur!`,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_13",
        },
        elsa_13: {
          id: 'elsa_1',
          speaker: 'Ato',
          text: ``,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/cutscene/death_crowd_1.ktx2',
          nextDialogId : "elsa_14",
          sfx : "doorSlam"
        },
        elsa_14: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          characterImage: '',
          backgroundImage: '/assets/cutscene/black.ktx2',
          nextDialogId : "elsa_15",
          sfx : "tinnitus",
          autoPlay : 3,
        },
        elsa_15: {
          id: 'elsa_1',
          speaker: '',
          text: `Yan! Bangun!`,
          characterImage: '',
          backgroundImage: '/assets/cutscene/black.ktx2',
          nextDialogId : "elsa_16",
        },
        elsa_16: {
          id: 'elsa_1',
          speaker: 'Bunga',
          fade: true,
          text: `Yan! Kamu bisa mendengar aku?`,
          characterImage: '/assets/character/v2/bunga_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_17",
        },
        elsa_17: {
          id: 'elsa_1',
          speaker: '',
          characterImage: '/assets/character/v2/bunga_a.png',
          text: ``,
          choices : [
            {
              text: 'Apa yang terjadi?',
              nextDialogId: 'elsa_18',
            },
            {
              text: 'Elsa, dimana Elsa?',
              nextDialogId: 'elsa_18',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : -1} },
            },
          ],
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_16",
          sfx : "punch"
        },
        elsa_18: {
          id: 'elsa_1',
          speaker: 'Bunga',
          text: `Tenang yan. Kamu barusan pingsan cukup lama.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_19",
        },
        elsa_19: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Elsa dibawa ke gereja oleh yang lain. `,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_20",
        },
        elsa_20: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Sebaiknya kamu menyusul `,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          storyAction: { type: 'nextDay', value: 2 },
        },
      },
    },
  },
];

export default config;
